import { NgModule } from '@angular/core';
import { KeycloakSessionProviderService } from './services/keycloak-session-provider.service';

@NgModule({
  providers: [KeycloakSessionProviderService],
})
export class TswpCoreAuthorizationKeycloakModule {}
